import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { _ } from "../../shared/images/icons";
import { ModalView } from "../../shared/Modal/ModalView";
import { clearError } from "../../actions/Actions";

export default function Modals({ type }) {
  const dispatch = useDispatch();
  const { showModal } = useSelector((state) => state.mainState);
  const { clients } = useSelector((state) => state.checkOtpState);
  const handleClose = () => {
    dispatch(clearError());
  };

  if (showModal) {
    switch (type) {
      case "sizeError":
        return (
          <ModalView
            acceptButton
            header="Файл весит больше 6 Мб"
            key="1"
            onFail={true}
            closeModal={handleClose}
            message={
              <span>
                Попробуйте загрузить с объёмом меньше или напишите в онлайн-чат
              </span>
            }
          />
        );

      case "typeError":
        return (
          <ModalView
            acceptButton
            header="Недопустимый файл"
            key="1"
            onFail={true}
            closeModal={handleClose}
            message={
              <span>
                Вы пытаетесь загрузить не допустимый файл. <br /> Загрузить
                можно файлы с типом <b>jpg</b>, <b>png</b>, <b>pdf</b>.
              </span>
            }
          />
        );
      case "selectUser":
        return (
          <ModalView
            header="Файл больше 6 Мб"
            key="1"
            closeModal={handleClose}
            userSelectDialog
            selectUsers={clients}
          />
        );
      case "uncorrectCode":
        return (
          <ModalView
            acceptButton
            header="Неверный код"
            key="1"
            onFail={true}
            closeModal={handleClose}
            message={<span>Проверьте правильность и повторите</span>}
          />
        );

      case "uncorrectPhone":
        return (
          <ModalView
            acceptButton
            header="Ошибка"
            key="1"
            onFail={true}
            closeModal={handleClose}
            message={<span>Неверный телефонный номер</span>}
          />
        );
      case "toManyUncorrectCode":
        return (
          <ModalView
            acceptButton
            header="Ошибка"
            key="1"
            onFail={true}
            closeModal={handleClose}
            message={<span>Слишком много попыток</span>}
          />
        );
      case "toManyrequestsErr":
        return (
          <ModalView
            acceptButton
            header="Ошибка"
            key="1"
            onFail={true}
            closeModal={handleClose}
            message={
              <span>Слишком много попыток попробуйте через 20 минут</span>
            }
          />
        );
      case "tokenNotFound":
        return (
          <ModalView
            redirect
            acceptButton
            header="Ошибка"
            key="1"
            onFail={true}
            closeModal={handleClose}
            message={<span>Недействительная ссылка</span>}
          />
        );
      case "unexpected":
        return (
          <ModalView
            redirect
            acceptButton
            header="Ошибка"
            key="1"
            onFail={true}
            closeModal={handleClose}
            message={<span>Неизвестная ошибка, попробуйте позже</span>}
          />
        );
      case "information":
        return (
          <ModalView
            acceptButton
            header="Что является подтверждением дохода клиента?"
            key="1"
            closeModal={handleClose}
            message={
              <span>
                {_} Справка о заработной плате за последние 6 месяцев <br />
                {_} Выписка с банка о денежных переводах <br />
                или выписка денежного оборота пластиковой карты <br />
                {_} Договор/Контракт <br />
                {_} Патент с квитанциями об уплате налогов за последние <br />
                три месяца (если таксист, то обязательно требуем <br />
                контракт, лицензию и путёвку (путевой лист)) <br />
                {_} Свидетельство (шаходатнома) с выпиской (иқтибос) и <br />
                квитанциями об уплате налогов за последние 3 месяца
                <br />
                {_} Пенсионная справка
              </span>
            }
          />
        );
      case "networkError":
        return (
          <ModalView
            acceptButton
            header="Ошибка"
            key="1"
            onFail={true}
            closeModal={handleClose}
            message={
              <span>
                Ошибка соединения с интернетом. Проверьте подключение и
                попробуйте ещё
              </span>
            }
          />
        );
      case "uncorrectAppId":
        return (
          <ModalView
            redirect
            acceptButton
            header="Ошибка"
            key="1"
            onFail={true}
            closeModal={handleClose}
            message={
              <span>Время ожидания запроса вышло, попробуйте заново</span>
            }
          />
        );
      case "expiredCode":
        return (
          <ModalView
            redirect
            acceptButton
            header="Ошибка"
            key="1"
            onFail={true}
            closeModal={handleClose}
            message={
              <span>Вы ввели устаревший код, пожалуйста попробуйте заново</span>
            }
          />
        );
      default:
        return null;
    }
  } else {
    return null;
  }
}

export const modalConfig = {};

export const ErrorTypes = {
  ToManyRequests: "err.too_many_requests.",
  NetworkError: "Network Error",
  UncorrectCode: "wrong OTP or invalid OTP",
  ToManyUncorrect: "err.otpID_invalid",
  FileSendError: "failed to get files",
  TryAfterOneHour: "err.too_more_requests",
  InvalidAppId: "err.appID_invalid",
  UncorrectPhoneNumber: "incorrect phone number",
  TokenNotFound: "token is invalid, not found data",
};
